<div class="p-4">
    <div class="container">
        <h1>Hi {{user?.firstName}}!</h1>
        <p>Welcome to Merchant Transfer API</p>
        <p><a routerLink="/accounts">Manage Users</a></p>
    </div>
</div>
